import React, { useEffect, useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";

import Modal from "../../components/modal";
import api from "../../services/api";

export default function List() {
  const [filters, setFilters] = useState({ status: "ACTIVE" });
  const [data, setData] = useState([]);
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const query = { search: filters.search, status: filters.status };
        const { ok, data } = await api.post("/perk/search", query);
        if (!ok) throw new Error("Error while fetching perks");
        setData(data);
      } catch (error) {
        console.error(error);
        toast.error("Error while fetching perks");
      }
    };
    fetchData();
  }, [filters]);

  return (
    <div className="px-8 py-12 space-y-8">
      <div className="max-w-3xl mx-auto text-center mb-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Exclusive Perks for Startups</h1>
        <p className="text-lg text-gray-600">
          Discover a curated collection of exclusive benefits and deals that Selego has negotiated for startups. From essential services to growth tools, these perks are designed
          to help your startup thrive.
        </p>
      </div>

      <div className="flex flex-row justify-between gap-4 mb-8">
        <div className="flex gap-4">
          <div>
            <button
              key="active"
              className={`px-6 py-2 rounded-full transition-all duration-200 bg-blue-500 text-white shadow-md"}`}
              onClick={() => setFilters({ ...filters, status: "ACTIVE" })}>
              Active Perks
            </button>
            <button
              key="inactive"
              className={`px-6 py-2 rounded-full transition-all duration-200 bg-gray-100 hover:bg-gray-200"}`}
              onClick={() => setFilters({ ...filters, status: "INACTIVE" })}>
              Coming Soon
            </button>
          </div>
        </div>
        <Create />
      </div>
      <Perks perks={data} />
    </div>
  );
};

const Perks = ({ perks }) => {
  return (
    <div className="space-y-4">
      <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {perks.map((e, i) => (
          <li key={i} className="list-none">
            <Card perk={e} />
          </li>
        ))}
      </ul>
    </div>
  );
};
const Card = ({ perk }) => {
  const navigate = useNavigate();

  return (
    <div 
      className="flex flex-col bg-white rounded-xl shadow-sm hover:shadow-xl transition-all duration-200 overflow-hidden h-full border border-gray-100 cursor-pointer"
      onClick={() => navigate(`/perks/${perk._id}`)}
    >
      <div className="flex justify-between p-6">
        <div className="relative">
          {perk.logo ? (
            <img src={perk.logo} alt={perk.name} className="object-contain rounded-xl w-28 h-28" />
          ) : (
            <div className="h-28 w-28 rounded-xl bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center text-3xl font-bold text-blue-500">{perk.name[0]}</div>
          )}
        </div>
      </div>
      <div className="flex flex-col flex-1 group p-6 pt-0">
        <div className="text-xl font-bold text-gray-900 group-hover:text-blue-500 transition-colors duration-200">{perk.name}</div>
        {perk.value && <div className="text-base font-semibold text-green-600 mt-1">€{perk.value}</div>}
        <div className="text-sm text-gray-600 mt-3 line-clamp-3">{perk.description}</div>
        <div className="flex-1" />
      </div>
    </div>
  );
};

const Create = () => {
  const [values, setValues] = useState({ name: "" });
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      const res = await api.post("/perk", values);
      if (!res.ok) throw res;
      toast.success("Perk created successfully!");
      setOpen(false);
      navigate(`/perks/${res.data._id}`);
    } catch (e) {
      console.log(e);
      toast.error("Failed to create perk", e.code);
    }
  };

  return (
    <>
      <button className="px-6 py-2 bg-blue-500 text-white rounded-full shadow-md hover:bg-blue-600 transition-all duration-200" onClick={() => setOpen(true)}>
        Request a New Perk
      </button>
      <Modal isOpen={open} className="max-w-3xl w-full p-6" onClose={() => setOpen(false)}>
        <div className="p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Request a New Perk</h2>
          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Perk Name</label>
              <input
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                name="name"
                placeholder="Enter perk name"
                value={values.name}
                onChange={(e) => setValues({ ...values, name: e.target.value })}
              />
            </div>
          </div>
          <div className="flex justify-end mt-8">
            <button className="px-6 py-2 bg-blue-500 text-white rounded-full shadow-md hover:bg-blue-600 transition-all duration-200" onClick={handleSubmit}>
              Submit Request
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};
